import { formatNumber } from "./formatNumber";

export const bpsToPercent = (bps: string | number) =>
  formatNumber(String(Number(bps) / 100), 2);
